module.exports = __webpack_public_path__ + "img/list-icon4.09bbe779.png";